import React, { useState } from 'react'
import { useFormik } from 'formik';
import { Button, Modal, Spinner } from 'react-bootstrap'
import { addUpdateLearnerQuestionRes, addUpdateLearnerQuestionTodo } from '../../LMS_Redux/LMS_Slices/Course/AddUpdateLearnerQuestion';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { MessageReplySchema } from './MessageSchema';

export default function MessageReply(props) {

    const { replyModal, setReplyModal, replyData, setReplyData, bool, setBool } = props
    // console.log(replyData)

    const dispatch = useDispatch()
    const [spinner, setSpinner] = useState(false)

    const initialValues = {
        fk_ask_id: replyData && replyData.id,
        course_id: replyData && replyData.course_id,
        title: replyData && replyData.title,
        description: replyData && replyData.description,
        answer: replyData && replyData.answer,
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: MessageReplySchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateLearnerQuestionTodo(values)).then(() => reply_res(action))
        },
    })

    const reply_res = (action) => {
        if (addUpdateLearnerQuestionRes && addUpdateLearnerQuestionRes.success) {
            setBool(!bool)
            setSpinner(false)
            setReplyModal(false)
            setReplyData()
            action.resetForm()
            toast.success(addUpdateLearnerQuestionRes.message, { position: "bottom-right" })
        } else {
            toast.error(addUpdateLearnerQuestionRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    const handleClose = () => {
        setReplyModal(false)
        setReplyData()
    }

    return (
        <>
            <Modal
                show={replyModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Message Reply to {replyData && replyData.ask_by_nc}</Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                    <Modal.Body>

                        <span style={{ color: '#9d9d9d' }}>Title</span>
                        <h6>{replyData && replyData.title}</h6>

                        <span style={{ color: '#9d9d9d' }}>Description</span>
                        <h6>{replyData && replyData.description}</h6>

                        <div className="mb-3">
                            <label htmlFor="exampleFormControlTextarea1" className="form-label form_label">Reply</label>
                            <textarea className="form-control form_input" id="exampleFormControlTextarea1" placeholder='Write a Reply here...' rows="5"
                                name='answer' value={values.answer || ''} onChange={handleChange} onBlur={handleBlur}
                            />
                            {errors.answer && touched.answer ? <span className='text-danger form_label'>{errors.answer}</span> : null}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                            {spinner ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className='ms-2'
                                />
                                : ''
                            }</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}
